"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _NuiPage = _interopRequireDefault(require("../components/NuiPage"));
var _nuiPage = require("../modules/nuiPage");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function mapStateToProps(state) {
  var baseUrl = state.baseUrl,
    userPrefs = state.userPrefs,
    nuiPage = state.nuiPage;
  return {
    baseUrl: baseUrl,
    userPrefs: userPrefs,
    nuiPage: nuiPage
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  fetchNuiPageData: _nuiPage.fetchNuiPageData
})(_NuiPage.default);